import React, { PureComponent } from "react";
import Login from "./Login";
import ForgotPassword from "../../views/forgot-password/ForgotPassword";
import SignUp from "../../views/signup/SignUp";
import Footer from "../../views/footer/Footer";
import {
  LoginPageWrapper,
  Logo,
  FooterWrapper,
  Content,
  Layer
} from "../styled";

export enum LoginMode {
  SignUp,
  ForgotPassword,
  Login
}

type LoginPageProps = {
  failureMessage?: string | null;
  authenticate: (username: string, password: string) => void;
  forgotPassword: (username: string) => void;
  signUp: (username: string) => void;
  isFetching: boolean;
  showEmailSendSuccessfully: boolean;
  toggleShowEmailSendSuccessfully: () => void;
  setFailureMessage: (message: string | null) => void;
};

type LoginPageState = {
  username: string;
  password: string;
  [x: number]: any;
  showForgotPassword: boolean;
  loginMode: LoginMode;
};

export default class LoginPage extends PureComponent<
  LoginPageProps,
  LoginPageState
> {
  constructor(props: LoginPageProps) {
    super(props);

    this.state = {
      username: "",
      password: "",
      showForgotPassword: false,
      loginMode: LoginMode.Login
    };

    this.toggleForgotPwd = this.toggleForgotPwd.bind(this);
    this.onSignIn = this.onSignIn.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onForgotPassword = this.onForgotPassword.bind(this);
    this.keyPressed = this.keyPressed.bind(this);
    this.onSignUp = this.onSignUp.bind(this);
  }

  userNameInput = React.createRef<HTMLInputElement>();

  componentDidUpdate(prevProps: LoginPageProps) {
    const { failureMessage } = this.props;

    if (!prevProps.failureMessage && failureMessage) {
      this.resetCredentials();
    }
  }

  onSignIn(event: any) {
    // Prevent `form` from submitting.
    event.preventDefault();

    this.props.authenticate(this.state.username, this.state.password);
  }

  onSignUp(event: any) {
    event.preventDefault();

    this.props.signUp(this.state.username);
  }

  onForgotPassword(event: any) {
    // Prevent `form` from submitting.
    event.preventDefault();

    this.props.forgotPassword(this.state.username);
  }

  changeLoginMode = (
    newLoginMode: LoginMode,
    successfullySend: boolean = false
  ) => {
    this.props.setFailureMessage(null);
    this.setState({ loginMode: newLoginMode });
    if (successfullySend) {
      this.setState({ username: "", password: "" });
      this.props.toggleShowEmailSendSuccessfully();
    }
  };

  toggleForgotPwd(successfullySend: boolean) {
    this.props.setFailureMessage(null);
    this.setState({ showForgotPassword: !this.state.showForgotPassword });
    if (successfullySend) {
      this.props.toggleShowEmailSendSuccessfully();
    }
  }

  keyPressed = (event: any) => {
    if (event.key === "Enter") {
      this.props.authenticate(this.state.username, this.state.password);
    }
  };

  resetCredentials = () => {
    this.setState({ password: "" });
    this.userNameInput.current!.focus();
  };

  handleInputChange = (event: any) => {
    const { target } = event;
    this.setState({ [target.name]: event.target.value });
  };

  getContent = () => {
    const {
      failureMessage,
      isFetching,
      showEmailSendSuccessfully
    } = this.props;
    const { username, password, loginMode } = this.state;

    switch (loginMode) {
      case LoginMode.Login:
        return (
          <Login
            username={username}
            password={password}
            userNameInput={this.userNameInput}
            handleInputChange={this.handleInputChange}
            changeLoginMode={this.changeLoginMode}
            keyPressed={this.keyPressed}
            onSignIn={this.onSignIn}
            isFetching={isFetching}
            failureMessage={failureMessage}
          />
        );

      case LoginMode.ForgotPassword:
        return (
          <ForgotPassword
            username={username}
            userNameInput={this.userNameInput}
            handleInputChange={this.handleInputChange}
            changeLoginMode={this.changeLoginMode}
            onForgotPassword={this.onForgotPassword}
            isFetching={isFetching}
            showEmailSendSuccessfully={showEmailSendSuccessfully}
            failureMessage={failureMessage}
          />
        );

      case LoginMode.SignUp:
        return (
          <SignUp
            username={username}
            userNameInput={this.userNameInput}
            handleInputChange={this.handleInputChange}
            changeLoginMode={this.changeLoginMode}
            onSignUp={this.onSignUp}
            isFetching={isFetching}
            showEmailSendSuccessfully={showEmailSendSuccessfully}
            failureMessage={failureMessage}
          />
        );

      default:
        break;
    }
  };

  render() {
    return (
      <LoginPageWrapper>
        <Logo>
          <img src="/mps-logo.png" width="350" alt="Morgan Project Services" />
        </Logo>
        <Content>
          <Layer>{this.getContent()}</Layer>
        </Content>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </LoginPageWrapper>
    );
  }
}
